import React from 'react';
import { Alert, AlertTitle, Box, Button } from '@mui/material';

import { useWidgetFrame } from '../frameContext';

/** Warning / info / error banner row (design "Banner"). The frame draws the edit controls. */
export default function BannerRow({ tone = 'warning', title, text, action, icon }) {
  const frame = useWidgetFrame();
  const edit = frame?.mode === 'edit';
  return (
    <Box>
      <Alert
        severity={tone}
        icon={icon}
        action={action && !edit ? <Button color="inherit" size="small" onClick={action.onClick}>{action.label}</Button> : null}
        sx={{ borderRadius: '12px', alignItems: 'center', '& .MuiAlert-message': { py: 0.5 } }}
      >
        {title ? <AlertTitle sx={{ fontWeight: 600, mb: 0.25 }}>{title}</AlertTitle> : null}
        {text}
      </Alert>
    </Box>
  );
}
